import angular from 'angular';

angular.module('cxRegistrations').directive('cxTaskTypeahead', [
  '$parse',
  function($parse) {
    return {
      restrict: 'E',
      replace: true,
      template: `<div class="dropdown dropdown-full-width" uib-dropdown ng-show="options.length" is-open="ddwOpen">
          <div class="input-group scrollable-typeahead {{iClass}}">
            <input type="text"
                   ng-disabled="disabled"
                   ng-model="selected"
                   uib-typeahead="item as item.label for item in options | filter:{search:$viewValue||''} | limitTo:limit "
                   typeahead-min-length="0"
                   typeahead-select-on-blur="false"
                   typeahead-select-on-exact="true"
                   typeahead-on-select="onSelect($item, $event)"
                   typeahead-template-url="taskTypeaheadTemplate.html"
                   typeahead-focus-first="false"
                   ng-blur="onBlur()"
                   ng-keydown="onKeyDown($event)"
                   ng-focus="ddwOpen=false"
                   class="form-control"
                   placeholder="{{placeholder || ('Select task'|translate)}}"
                   autocomplete="off"
            />
            <span class="input-group-btn" >
              <button id="taskDropdownToggle" class="btn btn-default dropdown-toggle btn-font-14" ng-disabled="disabled || !options.length" uib-dropdown-toggle>
                <span class="caret"></span>
              </button>
            </span>
          </div>
          <ul class="dropdown-menu" role="menu" style="max-height:300px;overflow-y:auto;">
            <li ng-repeat="op in options" ng-class="{'selected':op===selected}">
              <a href ng-click=onSelect(op)>
                <Todo-icon ng-if="op.isToDo" ng-class="{'margin-10L':true, 'greyed-out': op.status===0, 'orange': op.status===1, 'green': op.status===2, 'text-danger': op.status===3}"></Todo-icon>
                <i ng-if="!op.isToDo" class="fa" ng-class="{'margin-10L':op.level===0, 'fa-circle greyed-out': op.status===0, 'fa-circle orange': op.status===1, 'fa-circle green': op.status===2, 'fa-minus-circle text-danger': op.status===3}"></i>
                <span>{{op.label}}</span>
                <span ng-if="op.deadline">({{op.deadline | formatDate}})</span>
              </a>
            </li>
          </ul>
          <script type="text/ng-template" id="taskTypeaheadTemplate.html">
          <a>
            <Todo-icon ng-if="match.model.isToDo" ng-class="{'margin-10L':true, 'greyed-out': match.model.status===0, 'orange': match.model.status===1, 'green': match.model.status===2, 'text-danger': match.model.status===3}"></Todo-icon>
            <i ng-if="!match.model.isToDo" class="fa" ng-class="{'margin-10L':match.model.level===0, 'fa-circle greyed-out': match.model.status===0, 'fa-circle orange': match.model.status===1, 'fa-circle green': match.model.status===2, 'fa-minus-circle text-danger': match.model.status===3}"></i>
            <span ng-bind-html="match.label | uibTypeaheadHighlight:query"></span>
            <span ng-if="match.model.deadline">({{match.model.deadline | formatDate}})</span>
          </a>
          </script>
        </div>`,
      require: 'ngModel',
      scope: {
        orgOptions: '=options',
        disabled: '=?ngDisabled',
        placeholder: '@?',
        iClass: '@?',
      },
      link: function(scope, el, attrs, ngModel) {
        if (!ngModel) return;
        scope.limit = attrs.limit || 9999;

        scope.view2model = function(value) {
          ngModel.$setViewValue(value);
        };

        function findSelected(value) {
          return value == null || !scope.options.length
            ? null
            : scope.options.find(function(el) {
                //Match by id
                if (
                  typeof el === 'object' &&
                  typeof value === 'object' &&
                  typeof el.id === 'string' &&
                  typeof value.id === 'string'
                )
                  return angular.equals(el.id, value.id);
                return angular.equals(el, value);
              });
        }

        // when angular detects a change to the model,
        // we update our inner value
        ngModel.$render = function() {
          scope.value = ngModel.$viewValue;
          scope.selected = findSelected(scope.value) || scope.value;
        };

        var getLabel = function(item) {
          if (!item) return null;
          return item.label;
        };

        scope.onSelect = function(i, event) {
          scope.selected = i;
          scope.value = i;
          scope.view2model(scope.value);
        };

        function mapOptions() {
          scope.options =
            !scope.orgOptions || !angular.isArray(scope.orgOptions) ? [] : [...scope.orgOptions];
          scope.selected = findSelected(scope.value) || scope.value;
        }
        mapOptions();
        scope.$watchCollection('orgOptions', function(newValue, oldValue) {
          mapOptions();
          if (scope.autoSelect == 'true' && scope.options.length === 1 && !scope.selected)
            scope.onSelect(scope.options[0]);
        });

        //Clear textbox if value is not in option list
        scope.onBlur = function() {
          if (scope.selected == null) return;
          if (typeof scope.selected === 'string') {
            scope.onSelect(null);
            return;
          }
          if (scope.options.indexOf(scope.selected) < 0) scope.onSelect(null);
        };
      },
    };
  },
]);
